const domain: string = 'FAQ'

export const SAVE_FAQ: string = `${domain}/SAVE_FAQ`
